import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateNotificationMutationVariables = Types.Exact<{
  specialistId: Types.Scalars['ID']['input'];
  companyId: Types.Scalars['ID']['input'];
  channelType: Types.AccountsNotificationChannelType;
  adTypes: ReadonlyArray<Types.YalperAdType> | Types.YalperAdType;
  emailChannel: Types.AccountsEmailChannelInput;
  telegramChannel: Types.AccountsTelegramChannelInput;
  adTypeSensors: Types.AccountsAdTypeSensorsInput;
  monitorAdTypes?: Types.InputMaybe<ReadonlyArray<Types.YalperAdType> | Types.YalperAdType>;
}>;


export type CreateNotificationMutationPage = { readonly __typename?: 'RootMutationType', readonly createNotification: { readonly __typename?: 'AccountsNotification', readonly id: string } };

export type UpdateNotificationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  adTypes: ReadonlyArray<Types.YalperAdType> | Types.YalperAdType;
  emailChannel: Types.AccountsEmailChannelInput;
  adTypeSensors: Types.AccountsAdTypeSensorsInput;
  monitorAdTypes?: Types.InputMaybe<ReadonlyArray<Types.YalperAdType> | Types.YalperAdType>;
}>;


export type UpdateNotificationMutationPage = { readonly __typename?: 'RootMutationType', readonly updateNotification: { readonly __typename?: 'AccountsNotification', readonly id: string } };

export type CreateNotificationNewMutationVariables = Types.Exact<{
  input: Types.AccountsNotificationCreateInput;
}>;


export type CreateNotificationNewMutationPage = { readonly __typename?: 'RootMutationType', readonly createNotificationNew: { readonly __typename?: 'AccountsNotification', readonly id: string } };

export type UpdateNotificationNewMutationVariables = Types.Exact<{
  input: Types.AccountsNotificationUpdateInput;
}>;


export type UpdateNotificationNewMutationPage = { readonly __typename?: 'RootMutationType', readonly updateNotificationNew: { readonly __typename?: 'AccountsNotification', readonly id: string } };

export type DeleteNotificationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteNotificationMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteNotification: boolean };

export type DeleteSpecialistMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteSpecialistMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteSpecialist: boolean };


export const CreateNotificationDocument = gql`
    mutation CreateNotification($specialistId: ID!, $companyId: ID!, $channelType: AccountsNotificationChannelType!, $adTypes: [YalperAdType!]!, $emailChannel: AccountsEmailChannelInput!, $telegramChannel: AccountsTelegramChannelInput!, $adTypeSensors: AccountsAdTypeSensorsInput!, $monitorAdTypes: [YalperAdType!]) {
  createNotification(
    specialistId: $specialistId
    companyId: $companyId
    channelType: $channelType
    adTypes: $adTypes
    emailChannel: $emailChannel
    telegramChannel: $telegramChannel
    adTypeSensors: $adTypeSensors
    monitorAdTypes: $monitorAdTypes
  ) {
    id
  }
}
    `;
export type CreateNotificationMutationFn = Apollo.MutationFunction<CreateNotificationMutationPage, CreateNotificationMutationVariables>;

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      specialistId: // value for 'specialistId'
 *      companyId: // value for 'companyId'
 *      channelType: // value for 'channelType'
 *      adTypes: // value for 'adTypes'
 *      emailChannel: // value for 'emailChannel'
 *      telegramChannel: // value for 'telegramChannel'
 *      adTypeSensors: // value for 'adTypeSensors'
 *      monitorAdTypes: // value for 'monitorAdTypes'
 *   },
 * });
 */
export function useCreateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationMutationPage, CreateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationMutationPage, CreateNotificationMutationVariables>(CreateNotificationDocument, options);
      }
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = Apollo.MutationResult<CreateNotificationMutationPage>;
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<CreateNotificationMutationPage, CreateNotificationMutationVariables>;
export const UpdateNotificationDocument = gql`
    mutation UpdateNotification($id: ID!, $adTypes: [YalperAdType!]!, $emailChannel: AccountsEmailChannelInput!, $adTypeSensors: AccountsAdTypeSensorsInput!, $monitorAdTypes: [YalperAdType!]) {
  updateNotification(
    id: $id
    adTypes: $adTypes
    emailChannel: $emailChannel
    adTypeSensors: $adTypeSensors
    monitorAdTypes: $monitorAdTypes
  ) {
    id
  }
}
    `;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<UpdateNotificationMutationPage, UpdateNotificationMutationVariables>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      adTypes: // value for 'adTypes'
 *      emailChannel: // value for 'emailChannel'
 *      adTypeSensors: // value for 'adTypeSensors'
 *      monitorAdTypes: // value for 'monitorAdTypes'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationMutationPage, UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationMutationPage, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotificationMutationPage>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationMutationPage, UpdateNotificationMutationVariables>;
export const CreateNotificationNewDocument = gql`
    mutation CreateNotificationNew($input: AccountsNotificationCreateInput!) {
  createNotificationNew(input: $input) {
    id
  }
}
    `;
export type CreateNotificationNewMutationFn = Apollo.MutationFunction<CreateNotificationNewMutationPage, CreateNotificationNewMutationVariables>;

/**
 * __useCreateNotificationNewMutation__
 *
 * To run a mutation, you first call `useCreateNotificationNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationNewMutation, { data, loading, error }] = useCreateNotificationNewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationNewMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationNewMutationPage, CreateNotificationNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationNewMutationPage, CreateNotificationNewMutationVariables>(CreateNotificationNewDocument, options);
      }
export type CreateNotificationNewMutationHookResult = ReturnType<typeof useCreateNotificationNewMutation>;
export type CreateNotificationNewMutationResult = Apollo.MutationResult<CreateNotificationNewMutationPage>;
export type CreateNotificationNewMutationOptions = Apollo.BaseMutationOptions<CreateNotificationNewMutationPage, CreateNotificationNewMutationVariables>;
export const UpdateNotificationNewDocument = gql`
    mutation UpdateNotificationNew($input: AccountsNotificationUpdateInput!) {
  updateNotificationNew(input: $input) {
    id
  }
}
    `;
export type UpdateNotificationNewMutationFn = Apollo.MutationFunction<UpdateNotificationNewMutationPage, UpdateNotificationNewMutationVariables>;

/**
 * __useUpdateNotificationNewMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationNewMutation, { data, loading, error }] = useUpdateNotificationNewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationNewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationNewMutationPage, UpdateNotificationNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationNewMutationPage, UpdateNotificationNewMutationVariables>(UpdateNotificationNewDocument, options);
      }
export type UpdateNotificationNewMutationHookResult = ReturnType<typeof useUpdateNotificationNewMutation>;
export type UpdateNotificationNewMutationResult = Apollo.MutationResult<UpdateNotificationNewMutationPage>;
export type UpdateNotificationNewMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationNewMutationPage, UpdateNotificationNewMutationVariables>;
export const DeleteNotificationDocument = gql`
    mutation DeleteNotification($id: ID!) {
  deleteNotification(id: $id)
}
    `;
export type DeleteNotificationMutationFn = Apollo.MutationFunction<DeleteNotificationMutationPage, DeleteNotificationMutationVariables>;

/**
 * __useDeleteNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationMutation, { data, loading, error }] = useDeleteNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationMutationPage, DeleteNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationMutationPage, DeleteNotificationMutationVariables>(DeleteNotificationDocument, options);
      }
export type DeleteNotificationMutationHookResult = ReturnType<typeof useDeleteNotificationMutation>;
export type DeleteNotificationMutationResult = Apollo.MutationResult<DeleteNotificationMutationPage>;
export type DeleteNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationMutationPage, DeleteNotificationMutationVariables>;
export const DeleteSpecialistDocument = gql`
    mutation DeleteSpecialist($id: ID!) {
  deleteSpecialist(id: $id)
}
    `;
export type DeleteSpecialistMutationFn = Apollo.MutationFunction<DeleteSpecialistMutationPage, DeleteSpecialistMutationVariables>;

/**
 * __useDeleteSpecialistMutation__
 *
 * To run a mutation, you first call `useDeleteSpecialistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpecialistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpecialistMutation, { data, loading, error }] = useDeleteSpecialistMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpecialistMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpecialistMutationPage, DeleteSpecialistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpecialistMutationPage, DeleteSpecialistMutationVariables>(DeleteSpecialistDocument, options);
      }
export type DeleteSpecialistMutationHookResult = ReturnType<typeof useDeleteSpecialistMutation>;
export type DeleteSpecialistMutationResult = Apollo.MutationResult<DeleteSpecialistMutationPage>;
export type DeleteSpecialistMutationOptions = Apollo.BaseMutationOptions<DeleteSpecialistMutationPage, DeleteSpecialistMutationVariables>;